var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 36 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 22\" id=\"menu\"><path fill=\"#000\" fill-rule=\"evenodd\" d=\"M0 10h36v2H0zM0 0h36v2H0zm0 20h36v2H0z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol